import { useTask } from '@/ui/concerns';
import {
  inspectionsReportDownload,
} from '@/services/api/resources/inspection/exports';
import { saveAs } from 'file-saver';
import { StatusCodes } from 'http-status-codes';
import { extractFilenameFromDisposition } from '@/ui/helpers/uiHelper';

export const useInspectionExport = () => {
  const saveFileFromUrl = (url: string) => {
    const getRecord = useTask(
      () => inspectionsReportDownload(url),
      async res => {
        if (res.status === StatusCodes.OK) {
          const disposition = res.headers.get('Content-Disposition');
          if (disposition && disposition.indexOf('attachment') !== -1) {
            const filename = extractFilenameFromDisposition(disposition);
            if (filename) {
              const blob = await res.blob();
              const newBlob = new Blob([blob]);
              saveAs(newBlob, filename);
            }
          }
        }
      },
    );
    getRecord.run();
    return getRecord;
  };

  return {
    saveFileFromUrl,
  };
};
